import React, { Fragment } from 'react';

export default function IFrame(props) {
    return (
        <div className={props.className} style={{ ...props.style, height: 130, width: 340 }} dangerouslySetInnerHTML={{
            __html: props.src
        }} />
    );
}